import { FC } from 'react';

import { Modal } from '../../../../components/modal/index';
import { popupStore } from './popup.store';

export const DeletePerkPopup: FC = () => {
  const isOpen = popupStore(({ open }) => open);

  const handleAccept = popupStore(({ handleAccept }) => handleAccept);
  const handleDismiss = popupStore(({ handleDismiss }) => handleDismiss);

  return (
    <Modal
      description="Are you sure you want to delete this perk? The perk will be removed from the landing page and the app. This action cannot be undone."
      dismissButtonContent="Cancel"
      isOpen={isOpen}
      onDismiss={handleDismiss}
      onSuccess={handleAccept}
      successButtonContent="Delete"
      title="Delete Perk"
    />
  );
};
